import { Component, OnInit, Input, Output, OnChanges, ViewChild, AfterViewInit, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SettingsService } from 'src/app/services/settings.service';
import { UserService } from 'src/app/services/user.service';
import { FiaApplication } from 'src/app/shared/models/users/fia-application';
import { UserProfile } from 'src/app/shared/models/users/user-profile';
import { UserFiaPins } from 'src/app/shared/models/users/user-fia-pins';
import { TransactionService } from 'src/app/services/transaction.service';
import { Error } from 'src/app/shared/models/general/error';
import { FiaService } from 'src/app/services/fia.service';
import { FiaLeftToApplyFor } from 'src/app/shared/models/users/fia-left-to-apply-for';
import { DooyaFiaApplication } from 'src/app/shared/models/users/dooya-fia-application';
import { UserBilling } from 'src/app/shared/models/users/user-billing';

@Component({
  selector: 'app-fia-applications',
  templateUrl: './fia-applications.component.html',
  styleUrls: ['./fia-applications.component.scss'],
})
export class FiaApplicationsComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('userFiaApplicationsModal', { static: true })
  userFiaApplicationsModal: any;

  @Input() selectedUserProfile: UserProfile;
  @Input() selectedUserFiaApplcations: FiaApplication[] = [];
  @Input() showModal: boolean = false;

  @Output() showModalChange = new EventEmitter<boolean>();

  busy: boolean = false;
  showError: boolean;
  errorMsg: string = '';

  userProfile: UserProfile = new UserProfile();
  userFiaApplications: FiaApplication[] = [];
  userFiaPins: UserFiaPins[] = [];
  fiaLeftToApplyFor: FiaLeftToApplyFor = new FiaLeftToApplyFor();
  fiaLeftToApplyForMessage: string = '';
  fiaTotalAmountRequested: number = 0;
  pinTotalBalanceAvailable: number = 0;

  fiaAvailableAmount: number = 0;
  totalPinsAvailableAmount: number = 0;

  billingPlan: string = '';

  constructor(
    public settingsService: SettingsService,
    public usersService: UserService,
    public transactionsService: TransactionService,
    public activeModal: NgbActiveModal,
    public fiaService: FiaService
  ) {}

  ngOnInit(): void {}

  ngOnChanges() {
    this.billingPlan = UserBilling.GetDisplayNameById(this.selectedUserProfile.user?.userBilling[0].billingTypeId);

    this.showHideModal(null);
  }

  ngAfterViewInit(): void {}

  onClosed(event: any) {
    if (this.showModal != false) {
      this.showModal = false;
      this.showModalChange.emit(this.showModal);
    }
  }

  showHideModal(toggle: boolean) {
    if (toggle != null) {
      this.showModal = toggle;
    }

    if (this.showModal) {
      this.userFiaApplicationsModal.show();
      this.userProfile = <UserProfile>JSON.parse(JSON.stringify(this.selectedUserProfile));
      this.userFiaApplications = <FiaApplication[]>JSON.parse(JSON.stringify(this.selectedUserFiaApplcations));
      this.GetLeftToApplyFor();
    } else if (!this.showModal) {
      // Blur any focused element before hiding modal to prevent aria-hidden warning
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      this.clearErrors();
      this.userFiaApplicationsModal.hide();
    }

    this.showModalChange.emit(this.showModal);
  }

  GetLeftToApplyFor() {
    return new Promise((resolve) => {
      this.busy = true;
      this.clearErrors();
      this.fiaLeftToApplyFor = null;
      this.fiaService.CalculateLeftToApplyFor(this.userProfile.userId).subscribe({
        next: (response: FiaLeftToApplyFor) => {
          this.fiaLeftToApplyFor = response;
          this.busy = false;
          resolve(true);
        },
        error: (error) => {
          this.displayError(error);
          this.busy = false;
          resolve(true);
        },
      });
    });
  }

  public hasPinExpired(pin: string, pinExpiryDate: Date): boolean {
    if (!pin) {
      return false;
    }
    const now = new Date();
    const expiry = new Date(pinExpiryDate);
    if (now > expiry) {
      return true;
    }
    return false;
  }

  createdBy(app: FiaApplication): string {
    if (app.isAutoCreated) {
      return 'Auto';
    }

    if (app.userId == app.requestedByUserId) {
      return 'Client';
    }

    return 'Admin';
  }

  toggleDooyaData(app: FiaApplication) {
    if (!app.selected) {
      app.busy = true;
      app.selected = true;
      this.fiaService.GetDooyaFiaData(app.id).subscribe({
        next: (response: DooyaFiaApplication) => {
          app.dooyaFiaApplication = response;
          app.dooyaFiaApplication.errorMessage = '';
          app.busy = false;
        },
        error: (error) => {
          app.dooyaFiaApplication = new DooyaFiaApplication();
          app.dooyaFiaApplication.errorMessage = Error.InterpretErrorMessage(error);
          app.busy = false;
        },
      });
    } else {
      app.busy = false;
      app.dooyaFiaApplication = new DooyaFiaApplication();
      app.dooyaFiaApplication.errorMessage = '';
      app.selected = false;
    }
  }

  public TranslateDooyaState(dooyaAppState: number) {
    switch (dooyaAppState) {
      case 0:
        return 'Requested';
      case 1:
        return 'Verified';
      case 2:
        return 'Submitted';
      case 3:
        return 'Downloaded SARS Letter';
      case 4:
        return 'Docs Uploaded';
      case 5:
        return 'Submitted To SARS';
      case 6:
        return 'Completed';
      case 7:
        return 'Additional Docs Requested';
      case 8:
        return 'Uploading Additional Docs';
      case 9:
        return 'Additional Docs Uploaded';
      case 10:
        return 'Lodge Complaint';
    }

    return `Unknown (${dooyaAppState})`;
  }

  clearErrors() {
    this.errorMsg = '';
    this.showError = false;
  }

  displayError(error: any) {
    this.showError = true;
    this.errorMsg = Error.InterpretErrorMessage(error);
  }
}
